import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { getTranscheckRules, saveTranscheckRules } from "@/features/admin/api";

/** Transcript Check rules editor (`/admin/transcheck/rules`). */
export default function TranscheckRulesPage() {
  const [rules, setRules] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getTranscheckRules()
      .then(setRules)
      .catch(() => toast.error("Couldn't load the rules."));
  }, []);

  async function save() {
    setBusy(true);
    try {
      await saveTranscheckRules(rules);
      toast.success("Rules saved.");
    } catch {
      toast.error("Couldn't save the rules.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-4">
        <div>
          <CardTitle>Transcript Check Rules</CardTitle>
          <CardDescription>
            Parser test rules consumed by the transcript regression run (Transcripts, Tier 2.3).
          </CardDescription>
        </div>
        <Button asChild variant="outline" size="sm">
          <Link to="/admin/transcheck">Back to result</Link>
        </Button>
      </CardHeader>
      <CardContent className="grid gap-4">
        <Textarea
          rows={20}
          value={rules}
          onChange={(e) => setRules(e.target.value)}
          className="font-mono text-xs"
          placeholder="One rule per line…"
        />
        <div>
          <Button disabled={busy} onClick={() => void save()}>
            {busy ? "Saving…" : "Save rules"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
